import { render, staticRenderFns } from "./Approval.vue?vue&type=template&id=b3f4ceb4&scoped=true&"
import script from "./Approval.vue?vue&type=script&lang=ts&"
export * from "./Approval.vue?vue&type=script&lang=ts&"
import style0 from "./Approval.vue?vue&type=style&index=0&id=b3f4ceb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f4ceb4",
  null
  
)

export default component.exports